import React, { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { getMessaging, getToken } from "firebase/messaging";
import { auth, db, registerServiceWorkerAndGetToken } from "../firebaseConfig.js";
import { doc, updateDoc, getDoc } from "firebase/firestore";
import Loading from "../components/Loading.js";

// Crea el contexto
export const AuthContext = createContext();

// Hook personalizado para usar el contexto de autenticación
export const useAuth = () => {
  return useContext(AuthContext);
};

// Actualizar el fcmToken del usuario autenticado
const updateFcmToken = async (user) => {
  try {
    // Obtén el token de FCM
    const messaging = getMessaging();
    const fcmToken = await getToken(messaging, {
      vapidKey: "BHs7BcXobNlY8tdmMYov5-_Q1IOFPbHtsnzpbPfRZrI4RClavJ60bj6Q5cT0aMRC2jHtYjLx_G5zmKFb3U0BUp4", // Reemplaza con tu clave pública VAPID
    });

    if (fcmToken) {
      // Actualiza el token en el documento del usuario en Firestore
      const userDocRef = doc(db, "users", user.uid);
      await updateDoc(userDocRef, { fcmToken });
      console.log("fcmToken actualizado correctamente:", fcmToken);
    } else {
      console.warn("No se pudo obtener el fcmToken.");
    }
  } catch (error) {
    console.error("Error al actualizar el fcmToken:", error);
  }
};

// Proveedor del contexto de autenticación
export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null); // Usuario actual
  const [userRole, setUserRole] = useState(null); // Rol del usuario
  const [loading, setLoading] = useState(true); // Estado de carga

  useEffect(() => {
    // Listener para cambios en el estado de autenticación
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setLoading(true); // Muestra la pantalla de carga mientras se procesa
      if (user) {
        setCurrentUser(user);
        try {
          // Intenta obtener el rol del usuario desde Firestore
          const userDoc = await getDoc(doc(db, "users", user.uid));
          if (userDoc.exists()) {
            setUserRole(userDoc.data().role);
            // Actualiza el token FCM del usuario
            updateFcmToken(user);
          } else {
            console.warn("No se encontró un documento para este usuario.");
            setUserRole(null);
          }
        } catch (error) {
          console.error("Error al obtener el rol del usuario:", error);
          setUserRole(null);
        }
      } else {
        setCurrentUser(null);
        setUserRole(null);
      }
      setLoading(false); // Oculta la pantalla de carga
    });

    return unsubscribe; // Limpia el listener al desmontar
  }, []);

  // Llama a registerServiceWorkerAndGetToken en un efecto separado
  useEffect(() => {
    registerServiceWorkerAndGetToken()
      .then((token) => {
        if (token) {
          console.log("Token FCM registrado:", token);
        } else {
          console.warn("No se pudo obtener un token FCM.");
        }
      })
      .catch((error) => console.error("Error al registrar FCM:", error));
  }, []);

  // Función para cerrar sesión
  const logout = () => {
    return auth.signOut();
  };

  // Valores expuestos por el contexto
  const value = {
    currentUser,
    userRole,
    logout,
  };

  // Muestra un componente de carga mientras se inicializa el contexto
  if (loading) {
    return (
      <div id="carga" className="containerLoading">
        <Loading />
      </div>
    );
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
